import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Compass } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-secondary border-t border-border">
      <div className="container-page py-10 space-y-6">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <Compass className="h-4 w-4" />
          </span>
          <span className="font-heading font-bold tracking-[-0.02em]">{t.nav.brand}</span>
        </div>
        <p
          data-testid="footer-disclaimer"
          className="text-xs md:text-sm text-muted-foreground leading-relaxed max-w-3xl"
        >
          {t.footer.disclaimer}
        </p>
        <p className="text-xs text-muted-foreground">
          © {year} {t.nav.brand} — {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};
